import React from 'react';
import { TESTIMONIALS, PILOT_NOTE } from '../../data/dgpt';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
export function CustomersSection() {
  return <section id="customers" aria-labelledby="customers-heading" className="border-b border-hairline-soft bg-ink" data-id="element-19" data-mp="25n632hfmc84m">
      <div className="mx-auto w-full max-w-[1320px] px-4 py-20 sm:px-6 lg:px-8 lg:py-28" data-id="element-20" data-mp="21mdtto6qy38c">
        <SectionHeading eyebrow="Customers" headingId="customers-heading" title="Why Teams Pick Us Up." data-id="element-21" data-mp="1duypjpvetbug" />

        <ul className="mt-14 grid gap-4 md:grid-cols-2" data-id="element-22" data-mp="18yqeankc22sk">
          {TESTIMONIALS.map((testimonial, index) => <Reveal key={testimonial.person} as="li" delay={index * 0.05} className="flex flex-col justify-between gap-8 rounded-2xl border border-hairline bg-panel p-6 sm:p-8" data-id="element-23" data-mp="1mu29sx6bbxaj" data-mpi={index}>
              <figure className="flex h-full flex-col justify-between gap-8" data-id="element-24" data-mp="2tbh0tbq0proo">
                <blockquote className="text-[17px] leading-relaxed tracking-[-0.01em] text-text-primary" data-id="element-25" data-mp="11mnweqyrww5q">
                  “{testimonial.quote}”
                </blockquote>
                <figcaption className="flex items-center justify-between gap-4 border-t border-hairline-soft pt-5" data-id="element-26" data-mp="1amszwq0ujaem">
                  <span data-id="element-27" data-mp="1fmffh645d2ql">
                    <span className="block text-sm font-semibold text-text-primary" data-id="element-28" data-mp="1fkug936w0vme">{testimonial.person}</span>
                    <span className="block text-xs text-text-secondary" data-id="element-29" data-mp="hzq62b747nup">
                      {testimonial.role}, {testimonial.organization}
                    </span>
                  </span>
                  <span className="shrink-0 rounded-md border border-hairline-soft bg-elevated px-2 py-1 text-[10px] uppercase tracking-wider text-text-tertiary" data-id="element-30" data-mp="rvjfvmtg938s">
                    {testimonial.relationship}
                  </span>
                </figcaption>
              </figure>
            </Reveal>)}
        </ul>

        <Reveal delay={0.1} data-id="element-31" data-mp="44nqewcguk4p">
          <p className="mt-6 inline-flex items-center gap-2 rounded-lg border border-hairline-soft bg-panel/60 px-3 py-2 text-xs text-text-secondary" data-id="element-32" data-mp="3sb6x9hoesrc7">
            <span className="h-1.5 w-1.5 rounded-full bg-lime" aria-hidden="true" data-id="element-33" data-mp="3o9lbf6twd2pv" />
            {PILOT_NOTE}
          </p>
        </Reveal>
      </div>
    </section>;
}